import React from 'react'
import { selectShouldDisplayTopSearch } from '../../store/seo/seo.selectors'
import Details from '../genericComponents/Details'
import magnifyingGlass from '../genericComponents/assets/magnifying-glass.svg'
import T from '../i18n/T'
import TopSearchLinks from '../seo/footer/TopSearchLinks'
import SVGIcon from '../svg/SVGIcon'
import { withEverySelectorTruthy } from '../utils/react-redux'
import s from './FooterTopSearch.less'

export const FooterTopSearch = () => (
  <Details
    summary={
      <span>
        <SVGIcon url={magnifyingGlass} className="ssrFooterImg" />
        <T id={'footer.top-search'} />
      </span>
    }
    classes={[s.topSearchHover]}
    toggleClasses={[s.chevron]}
  >
    <TopSearchLinks />
  </Details>
)

export default withEverySelectorTruthy(selectShouldDisplayTopSearch)(FooterTopSearch)
